import { Asset } from '../types/asset/asset';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/asset/list';

export namespace AssetRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<Asset>> => {
    return (await http.post(LIST, payload)).data;
  };
}
